import { useEffect } from "react";

interface ToastMessagesProps {
  message: string;
  type?: "success" | "error" | "info" | "warning";
  onClose: () => void;
}

 export const ToastMessages = ({ message, type = "success", onClose }: ToastMessagesProps) => {
  useEffect(() => {
    const timer = setTimeout(() => onClose(), 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div
      className={`fixed top-5 right-5 px-4 py-2 rounded shadow-lg text-white
      ${type === "success" ? "bg-green-600" : ""}
      ${type === "error" ? "bg-red-600" : ""}
      ${type === "info" ? "bg-blue-600" : ""}
      ${type === "warning" ? "bg-yellow-600" : ""}
      animate-slide-in`}
    >
      {message}
    </div>
  );
};

 
